<nz-layout class="app-layout">
  <nz-sider
    class="menu-sidebar"
    nzWidth="256px"
    nzBreakpoint="md"
    nzTheme="light"
    [nzCollapsed]="isCollapsed()"
    (nzCollapsedChange)="setCollapsedState($event)"
  >
    <div class="sidebar-logo" [class.collapsed]="isCollapsed()">
      <a [routerLink]="sidebarHomeRouterLink()">
        <img src="assets/images/logo.png" alt="DirtRunner Logo" />
        <span *ngIf="!isCollapsed()">DirtRunner</span>
      </a>
    </div>
    <ul nz-menu nzTheme="light" nzMode="inline" [nzInlineCollapsed]="isCollapsed()">
      @for (item of commonMenuItems(); track item.route) {
        <li nz-menu-item nzMatchRouter>
          <a [routerLink]="item.route">
            <span nz-icon [nzType]="item.icon"></span>
            <span>{{ item.label }}</span>
          </a>
        </li>
      }

      @if (adminMenuItems().length > 0) {
        @if (showAdminMenuDivider()) {
          <li class="menu-divider" role="separator"></li>
        }
        <li nz-menu-item-group class="menu-section" [class.collapsed]="isCollapsed()">
          <span title *ngIf="!isCollapsed()" class="admin-title">Admin</span>
          <ul>
            @for (item of adminMenuItems(); track item.route) {
              <li nz-menu-item nzMatchRouter>
                <a [routerLink]="item.route">
                  <span nz-icon [nzType]="item.icon"></span>
                  <span>{{ item.label }}</span>
                </a>
              </li>
            }
          </ul>
        </li>
      }
    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="header-content">
        <div class="header-left">
          <button
            class="menu-toggle"
            (click)="setCollapsedState(!isCollapsed())"
            aria-label="Toggle menu"
          >
            <span nz-icon [nzType]="isCollapsed() ? 'menu-unfold' : 'menu-fold'"></span>
          </button>
        </div>
        <div class="header-right">
          <app-avatar
            [firstName]="avatarFirstName()"
            [lastName]="avatarLastName()"
            [role]="authStore.user()?.primaryRole || ''"
            [imageUrl]="authStore.user()?.avatar || ''"
            (profile)="goToProfile()"
            (logout)="logout()"
          ></app-avatar>
        </div>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        @if (showComplianceReminderBanner()) {
          <div
            class="compliance-reminder-banner"
            (click)="goToProfileDocuments()"
            (keydown.enter)="goToProfileDocuments()"
            tabindex="0"
            role="link"
            [attr.aria-label]="'Open Profile Documents to finish compliance uploads'"
          >
            <nz-alert
              nzType="warning"
              nzShowIcon
              nzMessage="Finish your compliance documents"
            ></nz-alert>
          </div>
        }
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
